import { DialogComponent } from '@theme/dialog';

/** Keep Loox's own detail window visible when opened from the aggregate dialog. */
class HomeReviews extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    if (this.id === 'BmhComboReviewsDialog' && !this.boundedClose) {
      this.boundedClose = true;
      const close = this.closeDialog;
      this.closeDialog = async () => {
        if (this.closing) return;
        this.closing = true;
        // Settle the theme's animation wait even when a background tab pauses frames.
        const deadline = setTimeout(() => {
          if (this.refs.dialog.classList.contains('dialog-closing')) {
            this.refs.dialog.getAnimations({subtree: false}).forEach(animation => animation.cancel());
          }
        }, 450);
        try { await close(); }
        finally { clearTimeout(deadline); this.closing = false; }
      };
    }
    this.life = new AbortController();
    this.addEventListener('dialog:close', () => this.watch?.disconnect(), { signal: this.life.signal });
  }
  showDialog() {
    super.showDialog();
    this.watch?.disconnect();
    this.watch = new MutationObserver(() => {
      const detail = document.getElementById('looxOverlay_quickview');
      if (detail && this.refs.dialog.open && getComputedStyle(detail).display !== 'none') {
        this.watch.disconnect();
        // Native dialogs sit above Loox's overlay: hand the screen to its detail view.
        this.closeDialog();
      }
    });
    this.watch.observe(document.body, { childList: true });
    const detail = document.getElementById('looxOverlay_quickview');
    if (detail) this.watch.observe(detail, { attributes: true, attributeFilter: ['style'] });
  }
  disconnectedCallback() { this.life?.abort(); this.watch?.disconnect(); super.disconnectedCallback(); }
}
if (!customElements.get('bmh-reviews-dialog')) customElements.define('bmh-reviews-dialog', HomeReviews);
